module.exports = __webpack_public_path__ + "img/friends.f4f5e566.svg";